// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3QjZZ","description":"PatientConsentPreview_description__cTaFO"};